<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" style="width:100%" title="产品介绍" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
             <img v-lazy="cas.Img" />
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.Title}}</p>
            <p class="abstract-content">{{cas.Content}}</p>
            <div class="more">
              <a :href="cas.Url" target="_blank">详细介绍 </a>
            </div>
            <a v-if="cas.FileUrl" :href="cas.FileUrl" target="_blank">下载 </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
      caseList: [
        {Id:1,Img:require('../assets/img/baobiao.png'),Title:"报表软件",Url:'https://mp.weixin.qq.com/s/MlRPSJNd9ToB0bDvmv6YZA'
        ,Content:"报表软件是免费的，可以根据excel生成唛头、码单等。" +
              "软件和操作说明点下方链接下载",FileUrl:"https://www.jianguoyun.com/p/Ddq6E8AQg5jZCxizo4oFIAA"},
        {Id:2,Img:require('../assets/img/maoyi.png'),Title:"贸易系统",Url:'https://mp.weixin.qq.com/s/zXLIeFSB64IoKmfc8mHG1Q'
          ,Content:"贸易系统有：销售、采购、生产、检验、仓库、财务等模块。" +
              "唛头、验货报告、码单、装箱单、对账单等自动生成。"+
              "移动端可查询订单进度、进行出入库、检验等操作。系统可根据客户需求定制。"},
        {Id:3,Img:require('../assets/img/houzheng.jpg'),Title:"后整系统",Url:'https://mp.weixin.qq.com/s/s4ikdsFFxZlNEBoEAR617Q'
          ,Content:"后整系统有：生产、刷卡、配胶、检验、仓库、财务等模块。" +
              "唛头、验货报告、码单、装箱单、对账单等自动生成。"+
              "系统可根据客户需求定制。"},
        {Id:4,Img:require('../assets/img/jianyan.png'),Title:"检验系统",Url:'https://mp.weixin.qq.com/s/tM6bA3s9vYuAUOsUBYrJ9w'
          ,Content:"后整系统有：生产、刷卡、配胶、检验、仓库、财务等模块。" +
              "唛头、验货报告、码单、装箱单、对账单等自动生成。"+
              "系统可根据客户需求定制。"},
      ]
    };
  },
  mounted() {
    // window.console.log("case");
    // this.$http
    //   .get("Cases/GetCasesAll")
    //   .then(response => {
    //     //console.log(response);
    //     this.caseList = response.data;
    //     //window.console.log(this.caseList);
    //     this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
  }
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #1F357D;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>